<template>
  <el-dialog
    title="巡查记录"
    :visible.sync="dialogVisible"
    width="85%"
    :before-close="handleClose"
    :modal="true"
    :close-on-click-modal="false"
  >
    <div class="container-dialog">
      <el-button
        @click="downloadImg"
        icon="el-icon-download"
        class="other"
        type="primary"
        style="margin-bottom: 10px"
        >导出</el-button
      >
      <common-table
        :select="false"
        :page="page"
        :maxHeight="600"
        :dataList="dataList"
        v-loading="loading"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      >
        <template v-slot:operation="{ scope }">
          <el-button
            @click="delBatchFun(scope.row.id)"
            style="color: #eb3538; font-size: 16px"
            type="text"
            >删除
          </el-button>
        </template>
      </common-table>
      <!-- <div class="item-box item-box1">
        <div class="item">{{ info.taskTitle }}</div>
        <div class="cs" v-if="info.hasHour < 0">超期</div>
        <div class="cs"   style="color: #FF8B46;" v-else>剩余{{ info.hasHour }}小时</div>
        <img
          v-if="info.taskLevel == '应急'"
          style="height:24px;"
          src="@/assets/image/yj.png"
          alt=""
        />
      </div>
      <div class="item-box item-box2">
        <img class="icon" src="@/assets/image/wz.png" alt="" />
        <div class="label">点位</div>
        <div class="value">{{ info.pointName }}</div>
      </div>
      <div class="item-box item-box2">
        <img class="icon" src="@/assets/image/jq.png" alt="" />
        <div class="label">网格</div>
        <div class="value">{{ info.communityName }} | {{ info.blockName }}</div>
      </div>
      <div class="item-box item-box2">
        <img class="icon" src="@/assets/image/sj.png" alt="" />
        <div class="label">创建时间</div>
        <div class="value">{{ info.createTime }}</div>
      </div> -->
      <!-- <div class="item-box item-box3">
        <img
          style="height:40px;margin-right:8px;"
          src="@/assets/image/zxr.png"
          alt=""
        />
        <div class="item1">张女士</div>
        <div class="item2">创建时间</div>
        <div class="item3">{{info.createTime}}</div>
      </div> -->
    </div>
    <!-- <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
    </span> -->
  </el-dialog>
</template>
<script>
import { indexBatchExp, indexBatchbatchPage, delOneBatch } from "@/api/task.js";
import commonTable from "@/components/table/index.vue";
export default {
  components: {
    commonTable
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    curId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      info: {},
      page: {
        size: 5,
        page: 1,
        total: 0
      },
      dataList: {
        tableData: [],
        columns: [
          {
            prop: "handleUserName",
            label: "姓名"
          },
          {
            prop: "handleTime",
            label: "提交时间"
          },
          {
            prop: "handleAddress",
            label: "地点"
          }
        ]
      },
      loading: false
    };
  },
  mounted() {
    this.detailTaskFun();
  },
  methods: {
    async detailTaskFun() {
      this.loading = true;
      this.dataList.columns = [
        {
          prop: "handleUserName",
          label: "姓名"
        },
        {
          prop: "handleTime",
          label: "提交时间"
        },
        {
          prop: "handleAddress",
          label: "地点"
        }
      ];
      const res = await indexBatchbatchPage({
        fillIndeFlowFlag: true,
        ghTaskId: this.curId,
        page: this.page.page,
        size: this.page.size,
        timeDescFlag: true
      });
      if (res.data.code == 200) {
        this.dataList.tableData = res.data.data.records
          ? res.data.data.records
          : [];
        this.dataList.tableData.forEach((item, index) => {
          item.indexFlows.forEach((itemLi, indexLi) => {
            item[`showZbmc${indexLi}`] =
              itemLi.handleStatus == "符合" ? "是" : "否";
            if (index == 0) {
              this.dataList.columns.push({
                prop: `showZbmc${indexLi}`,
                label: itemLi.showZbmc
              });
            }
          });
        });
        this.page.total = res.data.data.total;
        this.dataList.columns.push({
          slot: "operation", // 添加操作列
          label: "操作",
          width: "120"
        });
        this.loading = false;
      }
    },
    handleClose() {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit("update:dialogVisible", false);
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.detailTaskFun();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.detailTaskFun();
    },
    async downloadImg() {
      const res = await indexBatchExp({
        taskId: this.curId
      });
      let data = res.data;
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        "巡查记录" + new Date().getTime() + ".xlsx"
      );
      document.body.appendChild(link);
      link.click();
    },
    async delBatchFun(id) {
      this.$confirm("是否删除该数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          this.loading = true;
          let params = {
            id: id
          };
          const res = await delOneBatch(params);
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功"
            });
            this.detailTaskFun();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  },
  computed: {},
  watch: {}
};
</script>

<style scoped lang="less">
/deep/.el-dialog__header {
  border: none;
  height: 64px;
  padding: 24px 16px 16px 24px;
  background: none !important;

  .el-dialog__title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #494c4f;
  }
}

/deep/.el-dialog__body {
  padding: 24px;
}

/deep/.el-input {
  width: auto !important;
}
.container-dialog {
  height: 65vh;
  /deep/ .el-table {
    margin-bottom: 20px;
  }
  .item-box {
    display: flex;
    align-items: center;
  }
  .item-box1 {
    .item {
      margin-right: 8px;
      font-family: MiSans, MiSans;
      font-weight: 700;
      font-size: 24px;
      color: #494c4f;
    }
    .cs {
      margin-right: 8px;
      background: rgba(235, 53, 56, 0.1);
      border-radius: 4px;
      padding: 2px 8px;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 16px;
      color: #eb3538;
    }
  }
  .item-box2 {
    margin-top: 12px;
    .icon {
      // width: 22px;
      height: 18px;
      margin-right: 10px;
    }
    .label {
      padding: 0;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 16px;
      color: #92979c;
      margin-right: 12px;
    }
    .value {
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 16px;
      color: #494c4f;
    }
  }
  .item-box3 {
    margin-top: 12px;
    .item1 {
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 16px;
      color: #494c4f;
      margin-right: 21px;
    }
    .item2 {
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 14px;
      color: #92979c;
      margin-right: 8px;
    }
    .item3 {
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 14px;
      color: #494c4f;
    }
  }
}

/deep/ .block {
  right: 25px;
}
</style>



// WEBPACK FOOTER //
// src/pages/task/longInspectionTask/components/addDialog.vue